import type { JSX } from "react";
import { PLOT_BASELINE_COLOR } from "./plot-geometry";
import type { PlotLayout } from "./plot-layout";

/**
 * Absolutely-positioned DOM layer whose box edges ARE the plot rect, drawn over the ECharts canvas
 * to carry the baseline under the plot. `pointer-events-none` so it never blocks chart hover.
 */
export function PlotChromeLayer({ layout }: { layout: PlotLayout }): JSX.Element {
    return (
        <div
            className={"pointer-events-none absolute border-b"}
            style={{
                borderColor: PLOT_BASELINE_COLOR,

                // bottom needs a bit of a nudge to not clip the line
                left: layout.gutters.left,
                right: layout.gutters.right,
                top: 0,
                bottom: layout.xAxisBandPx - 1,
            }}
        />
    );
}
